export default __webpack_public_path__ + "static/repairShoes-8c4005bd3eaaab875826b1bde0e51004.jpg";